import AxiosInstance from 'src/shared/services/axios/interceptor';

const controller = 'helppages/media';

// Samma gränser som API:t. Kontrolleras före uppladdningen, eftersom servern svarar utan meddelande på riktigt stora
// filer.
export const MAX_HELP_IMAGE_SIZE = 5 * 1024 * 1024;
export const MAX_HELP_VIDEO_SIZE = 20 * 1024 * 1024;

const createFormData = (file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  return formData;
};

// Laddar upp en bild till hjälpartiklarnas lagring i Azure Blob. Svaret är adressen relativt API:t (help/media/{id}).
// skipErrorToast: editorn visar API:ts meddelande själv.
export const uploadHelpPageMedia = (file: File) => {
  return AxiosInstance.post<{ location: string }>(controller, createFormData(file), { skipErrorToast: true });
};

// Laddar upp en video (mp4) på samma sätt, med förloppet i procent. Utan tidsgräns: 20 MB tar längre än instansens
// minut på ett långsamt nät.
export const uploadHelpPageVideo = (file: File, onProgress: (percent: number) => void) => {
  return AxiosInstance.post<{ location: string }>(`${controller}/video`, createFormData(file), {
    skipErrorToast: true,
    timeout: 0,
    onUploadProgress: (event: ProgressEvent) => {
      if (event.total) onProgress(Math.round((event.loaded / event.total) * 100));
    },
  });
};
